var m = require('mithril');
var prop = require('mithril/stream')
var key = require('../../libs/keybindings');
var telegraph = require('../../libs/Telegraph');
var buttonElement = require('../../components/button');
var pageScrollLock = require('./pageScrollLock');

var modal = {};
var releasePageScrollLock = null;

telegraph(modal);

function normalizePointRid(point) {
  var rid = point && typeof point === 'object' ? point['@rid'] : point;
  if (typeof rid !== 'string' || !rid) return null;
  return rid[0] === '#' ? rid : '#' + rid;
}

function isEditableElement(target) {
  var node = target;
  while (node) {
    var tagName = node.tagName ? node.tagName.toUpperCase() : '';
    if (tagName == 'INPUT' || tagName == 'TEXTAREA' || tagName == 'SELECT') return true;
    if (node.isContentEditable) return true;
    node = node.parentNode;
  }
  return false;
}

modal.vm = {
  title: prop(null),
  buttons: prop([]),
  buttonsClass: prop(''),
  body: 'span',
  opened: prop(false),
  width:prop(null),
  hideCloseIcon: prop(false),
  backdropMouseDown: false,
  suppressedPointRids: new Set(),
  setSuppressedPointUpdates: function (points) {
    var pointList = Array.isArray(points) ? points : (points ? [points] : []);
    modal.vm.suppressedPointRids = new Set(pointList.map(normalizePointRid).filter(Boolean));
  },
  isPointUpdateSuppressed: function (point) {
    var pointRid = normalizePointRid(point);
    return !!pointRid && modal.vm.suppressedPointRids.has(pointRid);
  },
  open: function (options) {
    modal.vm.setSuppressedPointUpdates(options && options.suppressPointUpdates);
    modal.vm.opened(true);
    if (!releasePageScrollLock) {
      releasePageScrollLock = pageScrollLock.acquire();
    }
    modal.emit('opened');
    key.setScope('modal');
    if(options && options.extrawidth) {
        modal.vm.width(options.extrawidth)
    }
  },
  close : function (arg) {
    modal.vm.opened(false);
    modal.vm.setSuppressedPointUpdates([]);
    if (releasePageScrollLock) {
      releasePageScrollLock();
      releasePageScrollLock = null;
    }
    key.deleteScope('modal');
    key.setScope('home');
    modal.emit('closed');
    modal.vm.width(null);
    modal.vm.hideCloseIcon(false);
    modal.vm.buttons([]);
    modal.vm.buttonsClass('');
    modal.vm.backdropMouseDown = false;
    // Clear any text selection that may have occurred while closing
    try {
      var sel = window.getSelection ? window.getSelection() : (document.selection || null);
      if (sel) {
        if (sel.removeAllRanges) sel.removeAllRanges();
        else if (sel.empty) sel.empty();
      }
    } catch (e) {}
    modal.vm.body = prop(m('div')); // Trigger onremove for body 
  },
}

key('esc', 'modal', function () {
  if (modal.vm.hideCloseIcon()) return;
  modal.vm.close();
});

modal.view = function (ctrl) {
  return m("div.bg-dark-gray", {style: {display: (modal.vm.opened() ? 'block' : 'none')}}, [
    m("div.fixed.top-0.h-100.w-100.pb5", {
      onkeydown: function (e) {
        if (!isEditableElement(e.target || e.srcElement)) return;
        if (e.key === 'Enter' || e.key === 'Escape') return;
        e.stopPropagation();
      },
      // Require both mousedown + mouseup on backdrop to trigger close
      onmousedown: function(e) {
        if (e.target === this && !modal.vm.hideCloseIcon()) {
          modal.vm.backdropMouseDown = true;
        }
      },
      onmouseup: function(e){
        if (modal.vm.backdropMouseDown && e.target === this && !modal.vm.hideCloseIcon()) {
          modal.vm.close();
        }
        modal.vm.backdropMouseDown = false;
      },
      style: {
        visibility: (modal.vm.opened() ? 'visible' : 'hidden'),
        background: 'rgba(0, 0, 0, 0.4)',
        zIndex: 2000,
        overflowX: 'hidden',
        overflowY: 'auto',
        overscrollBehavior: 'contain'
      },
      id: 'modal-id-to-focus'
    }, [
      (function(){
        if(!modal.vm.width()){
          return m("div.bg-black.mt5.mh5.pa4.w-50-l.w-50-m.w-100-ns.center", {zIndex: 1000}, [
                  modal.vm.hideCloseIcon() ? null : m('i.ion-close.fr', {onclick: modal.vm.close}),
                  m("h2.fw3.mb4", modal.vm.title()),
                  (typeof modal.vm.body === 'function' ? modal.vm.body(): m(modal.vm.body)),
                  m('div.mt1.tc.tr-ns.mt4.cf' + (modal.vm.buttonsClass() ? ' ' + modal.vm.buttonsClass() : ''), [
                    modal.vm.buttons().map(function (button) {
                      return m(buttonElement, button)
                    })
                  ])
                ])
        } else {
            return m("div.bg-black.mt5.mh5.pa4.w-75-l.w-75-m.w-100-ns.center", {zIndex: 1000}, [
              modal.vm.hideCloseIcon() ? null : m('i.ion-close.fr', {onclick: modal.vm.close}),
              m("h2.fw3.mb4", modal.vm.title()),
              (typeof modal.vm.body === 'function' ? modal.vm.body(): m(modal.vm.body)),
              m('div.mt1.tc.tr-ns.mt4.cf' + (modal.vm.buttonsClass() ? ' ' + modal.vm.buttonsClass() : ''), [
                modal.vm.buttons().map(function (button) {
                  return m(buttonElement, button)
                })
              ])
            ])
          }
      })(),
    ])
  ])
}

module.exports = modal;
